'use client';

import React, { useState } from 'react';
import { Link } from 'gatsby';
import { useTranslation } from 'react-i18next';
import UtilityButton from '../buttons/utilityButton';
import BgMedia from '../content/backgrounds/bg_media';
import { getLink } from '../../utils/link';
import { HotelUtility } from '../hotel/hotel_title';
import SkibusIcon from '../atoms/icons/skibus';
import SkiliftIcon from '../atoms/icons/skilift';
import TownCentreIcon from '../atoms/icons/towncentre';
import { useBookingContext } from '../../contexts/bookingContext';
import HotelRequest from './hotelRequest';
import STSHotelIcon from '../atoms/icons/sts_hotel';
import ButtonBooking from '../buttons/button_booking';

const HotelCard = ({ hotel, season, priceType }) => {
  const { t } = useTranslation(['booking']);
  const {
    setVisible,
    setSeason,
    setHotel,
    setIsFullscreenModal,
    setDepartureDate,
  } = useBookingContext();

  const show = () => {
    setSeason(season?.toLowerCase());
    setDepartureDate(price.checkinDate);
    setHotel({ id: hotel.id, name: hotel.name });
    setVisible(true);
    setIsFullscreenModal(true);
  };

  const [showRequestForm, setShowRequestForm] = useState(false);

  const price = hotel.lowestPrice;

  const mediaParams = {
    backgroundMedia: {
      alt: hotel.name,
      parentWidth: 'w-1/3',
      forceAspect: 'aspect-4/3',
      zIndex: 'z-0',
    },
    imageId: hotel?.images[0]?.id,
  };
  const showPrice = true;

  let label = t('Book now');
  if (showPrice && price) {
    label = t('StartingPrice', {
      price: price.lowestPerPersonPrice.toLocaleString('sv-SE'),
    });
  } else if (!price) {
    if (hotel?.field_coming_soon_boolean) {
      label = t('Coming soon');
    } else {
      label = t('Send request');
    }
  }

  return (
    <section
      key={hotel.id}
      className="flex flex-col justify-between col-span-12 sm:col-span-6 lg:col-span-4 mt-4 h-auto bg-yellow-15 rounded"
    >
      <div className="flex flex-col justify-start">
        <Link
          className="mb-4 px-0 w-full aspect-4/3 relative"
          to={getLink(hotel.full_slug)}
        >
          <BgMedia mediaParams={mediaParams} />
          <div className="absolute bottom-0  flex bg-white rounded-lg m-2">
            <div
              className={`flex items-center flex-nowrap bg-white rounded-l-lg pl-2 mr-[1px]`}
            >
              <div
                className={`flex flex-nowrap items-center w-auto py-2 pr-2 `}
              >
                <SkiliftIcon />
              </div>
              <span className="text-xs pr-2">{hotel.distanceToLift} m</span>
            </div>
            <div
              className={`flex items-center flex-nowrap bg-white pl-2 mr-[1px]`}
            >
              <div
                className={`flex flex-nowrap items-center w-auto py-2 pr-2 `}
              >
                <SkibusIcon />
              </div>
              <span className="text-xs pr-2">{hotel.distanceToSkibus} m</span>
            </div>
            <div
              className={`flex items-center flex-nowrap bg-white rounded-r-lg pl-2`}
            >
              <div
                className={`flex flex-nowrap items-center w-auto py-2 pr-2 `}
              >
                <TownCentreIcon />
              </div>
              <span className="text-xxs pr-2">
                {hotel.distanceToTownCentre} m
              </span>
            </div>
          </div>
          {hotel.sts_hotel && (
            <div className="absolute top-0 right-0 flex m-2">
              <div className="w-16">
                <STSHotelIcon />
              </div>
            </div>
          )}
        </Link>

        <Link
          className="flex flex-col justify-between px-8 md:px-8 no-underline"
          to={getLink(hotel.full_slug)}
        >
          <HotelUtility hotel={hotel} textStyle="base" />
          {(hotel.field_listing_text_string &&
            hotel.field_listing_text_string !== 'XXX') ||
          !hotel.descriptions ||
          hotel.descriptions.length === 0 ? (
            <p className="text-sm pb-0 hide-h2">
              {hotel.field_listing_text_string}
            </p>
          ) : (
            <div
              className={`text-sm pb-0 hide-h2 line-clamp`}
              dangerouslySetInnerHTML={{
                __html: hotel.descriptions[0].value,
              }}
            ></div>
          )}
        </Link>
      </div>
      <div className="px-4 pt-4">
        {showPrice && price && (
          <span className="text-xxs py-2 px-4 md:px-4">
            {price && price.packageShortInfo}
          </span>
        )}
        <div className="-mx-1">
          <ButtonBooking
            hotel={{
              id: hotel.id,
              name: hotel.name,
              coming_soon: hotel.field_coming_soon_boolean,
            }}
            blok={{ label: label }}
            season={season}
            destination={hotel.destinationId}
            price={price}
            priceType={priceType}
            showPackageInfo={false}
          />
        </div>
      </div>
      <HotelRequest
        showRequestModal={showRequestForm}
        setShowRequestModal={setShowRequestForm}
        hotel={hotel}
      />
    </section>
  );
};

export default HotelCard;
